import type { IconData } from '@stacksjs/iconify-core'

export const listNumberedRtl: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M40 80h288v32H40zm0 160h288v32H40zm0 160h288v32H40zm400-240V40h-64v32h32v88zm-64 102.111V312h80v-32h-44.223L456 257.889V192h-80v32h48v14.111zM376 440v32h80V344h-80v32h48v16h-24v32h24v16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default listNumberedRtl
